export default [
  { value: 'PIECE', label: 'db' },
  { value: 'KILOGRAM', label: 'kg' },
  { value: 'TON', label: 'tonna' },
  { value: 'KWH', label: 'kWh' },
  { value: 'DAY', label: 'nap' },
  { value: 'HOUR', label: 'óra' },
  { value: 'MINUTE', label: 'perc' },
  { value: 'MONTH', label: 'hónap' },
  { value: 'LITER', label: 'liter' },
  { value: 'KILOMETER', label: 'km' },
  { value: 'CUBIC_METER', label: 'köbméter' },
  { value: 'METER', label: 'meter' },
  { value: 'CARTON', label: 'karton' },
  { value: 'PACK', label: 'csomag' },
  { value: 'OWN', label: 'egyéb' },
];
